import React from "react";
import { Routes, Route, useLocation } from "react-router-dom"; // Import useLocation
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import Services from "./components/Services";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";

import AboutUs from "./components/AboutUs";
import GoogleReviews from "./components/GoogleReviews";
import LocationMap from "./components/LocationMap";
import CtaBanner from "./components/CtaBanner";

// Import your service pages
import GeneralDentistry from "./pages/GeneralDentistry";
import CosmeticDentistry from "./pages/CosmeticDentistry";
import Orthodontics from "./pages/Orthodontics";
import TeethWhitening from "./pages/TeethWhitening";
import RootCanalTreatment from "./pages/RootCanalTreatment";
import CrownsBridges from "./pages/CrownsBridges";
import BracesAligners from "./pages/BracesAligners";
import WisdomTeethRemoval from "./pages/WisdomTeethRemoval";
import Dentures from "./pages/Dentures";
import Implants from "./pages/Implants";
import LaserDentistry from "./pages/LaserDentistry";
import FlapSurgeries from "./pages/FlapSurgeries";
import FacialBoneFractures from "./pages/FacialBoneFractures";
import KidsBraces from "./pages/KidsBraces";
import ChildDentalCare from "./pages/ChildDentalCare";
import TMJPain from "./pages/TMJPain";
import CystsAndTumoursOfJaws from "./pages/CystsAndTumoursOfJaws";
import OralCancer from "./pages/OralCancer";
import JawAbnormalities from "./pages/JawAbnormalities";

const App = () => {
  const location = useLocation();

  const isHomePage = location.pathname === "/";
  const isContactPage = location.pathname === "/contact";

  return (
    <div>
      <Navbar />
      {/* Render HeroSection and AboutUs only on the main page */}
      {isHomePage && (
        <>
          <HeroSection />
          <AboutUs />
        </>
      )}

      <Routes>
        <Route path="/" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />

        {/* Add routes for each service page */}
        <Route
          path="/services/general-dentistry"
          element={<GeneralDentistry />}
        />
        <Route
          path="/services/cosmetic-dentistry"
          element={<CosmeticDentistry />}
        />
        <Route path="/services/orthodontics" element={<Orthodontics />} />
        <Route path="/services/teeth-whitening" element={<TeethWhitening />} />
        <Route
          path="/services/root-canal-treatment"
          element={<RootCanalTreatment />}
        />
        <Route path="/services/crowns-bridges" element={<CrownsBridges />} />
        <Route path="/services/braces-aligners" element={<BracesAligners />} />
        <Route
          path="/services/wisdom-teeth-removal"
          element={<WisdomTeethRemoval />}
        />
        <Route path="/services/dentures" element={<Dentures />} />
        <Route path="/services/implants" element={<Implants />} />
        <Route path="/services/laser-dentistry" element={<LaserDentistry />} />
        <Route path="/services/flap-surgeries" element={<FlapSurgeries />} />
        <Route
          path="/services/facial-bone-fractures"
          element={<FacialBoneFractures />}
        />
        <Route path="/services/kids-braces" element={<KidsBraces />} />
        <Route
          path="/services/child-dental-care"
          element={<ChildDentalCare />}
        />
        <Route path="/services/tmj-pain" element={<TMJPain />} />
        <Route
          path="/services/cysts-tumours-jaws"
          element={<CystsAndTumoursOfJaws />}
        />
        <Route path="/services/oral-cancer" element={<OralCancer />} />
        <Route
          path="/services/jaw-abnormalities"
          element={<JawAbnormalities />}
        />
      </Routes>

      {/* Render these components only on the main page */}
      {isHomePage && (
        <>
          <GoogleReviews />
          <LocationMap />
          <CtaBanner />
        </>
      )}

      {/* Render Footer on Home and Contact pages */}
      {(isHomePage || isContactPage) && <Footer />}

      {/* Vercel Web Analytics & Speed Insights */}
      <Analytics />
      <SpeedInsights />
    </div>
  );
};

export default App;
